import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { FabricTrimsMasterVersions } from "../../entities/tech-pack-versions/fabric-trims-master-versions.entity";


@Injectable()
export class FabricTrimsMasterVersionsRepo extends Repository<FabricTrimsMasterVersions> {

    constructor(@InjectRepository(FabricTrimsMasterVersions) private fabricTrimsMasterRepo: Repository<FabricTrimsMasterVersions>
    ) {
        super(fabricTrimsMasterRepo.target, fabricTrimsMasterRepo.manager, fabricTrimsMasterRepo.queryRunner);
    }

}